import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getDepostionReport } from "reduxStore/action/webReportActions";
// import { getReportPropertyList } from "reduxStore/action/reportActions";
// import TableDataNotFound from "component/TableDataNotFound";
import strings from "translate/language";
import { handleListResponse } from "utils/utils";
import Breadcrumb from "component/common/breadcrumb";
import Select from "react-select";
import ExcelJS from "exceljs";
import { getAllProperty } from "reduxStore/action/propertyActions";
import Pagination from "component/common/Pagination";
// import usePage from "utils/usePage";

const DepositionReport = ({ isAuth = false }) => {
  const dispatch = useDispatch();
  const [formVaild, setFormVaild] = useState({});
  const [endDateDisable, setEndDateDisable] = useState(true);
  const todayDate = new Date().toISOString().split("T")[0];
  const [form, setForm] = useState({
    property_title: "",
    start_date: todayDate,
    end_date: todayDate,
  });

  const [propertyList, setPropertyList] = useState([]);
  const [reportData, setReportData] = useState(null);
  const [loading, setLoading] = useState(true); // Loading state
  const [apiError, setApiError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [currentPage, setCurrentPage] = useState(0); // Current page number (0-indexed)
  const [totalRecords, setTotalRecords] = useState(0); // Total records from API
  const itemsPerPage = 10; // Records per page
  const tableContainerRef = useRef(null); // Reference for scroll container
  const reportDatas = useSelector((state) => state.webreport.depositionReport);
  const propertySelector = useSelector((state) => state.propertyData);

  const columnsForExcel = [
    { header: "Sr.No.", key: "sr_no", width: 10 },
    { header: "Region", key: "region", width: 15 },
    { header: "Visit Type", key: "revisitType", width: 15 },
    { header: "Date", key: "created_date", width: 15 },
    { header: "Client Name", key: "customer_name", width: 20 }, // moved up
    { header: "Property Title", key: "property_name", width: 40 },
    { header: "Mobile", key: "customer_mobile", width: 20 },
    // { header: "Role Title", key: "role_title", width: 20 },
    { header: "Email", key: "customer_email", width: 30 },
    { header: "Resi. Location", key: "customer_location", width: 20 },
    { header: "Profession", key: "customer_designation", width: 20 },
    { header: "Work Location", key: "customer_office_address", width: 20 },
    { header: "Ethnicity", key: "ethnicity", width: 20 },
    { header: "Visiting With", key: "visit_with", width: 20 },
    { header: "Visitor Status", key: "qualified", width: 20 },
    { header: "Lead Priority", key: "lead_priority", width: 20 },
    {
      header: "Possession Period",
      key: "expected_possession_period",
      width: 25,
    },
    { header: "Config", key: "configuration", width: 15 },
    { header: "Budget", key: "budget", width: 15 },
    { header: "Purpose", key: "purpose", width: 20 },
    { header: "Lead Source", key: "lead_source", width: 20 },
    { header: "CP Firm Name", key: "cp_firm_name", width: 50 },
    { header: "CP Name", key: "cp_name", width: 50 },
    { header: "CP Contact", key: "cp_contact", width: 20 },
    { header: "RERA Number", key: "rera_number", width: 20 },
    { header: "Referrer Name", key: "referrer_name", width: 30 },
    { header: "Referrer Contact", key: "referrer_contact", width: 20 },
    { header: "Sourcing Manager", key: "sourcing_manager", width: 30 },
    { header: "Closing Manager", key: "closing_manager", width: 30 },
    { header: "Lead Status", key: "lead_status", width: 20 },
    { header: "Walkin - Remark", key: "first_appointment_remarks", width: 60 },
    { header: "1st Follow-Up Date", key: "first_followup_date", width: 30 },
    { header: "Follow-up Remark", key: "last_followup_remark", width: 60 },
    // { header: "NFD", key: "second_followup_date", width: 20 },
    // { header: "STATUS", key: "followup_status", width: 20 },
    { header: "Lost Reason", key: "lost_reason", width: 60 },
    { header: "Lost Remark", key: "lost_remark", width: 60 },
    { header: "Revisit Date", key: "revisit_appointment", width: 20 },
  ];

  useEffect(() => {
    // Hide global loader for this page
    const loaderElement = window.document.getElementById("loaderoverlay");
    if (loaderElement) {
      loaderElement.style.display = "none";
    }

    // Fetch initial data with pagination params
    dispatch(
      getDepostionReport({
        limit: itemsPerPage,
        offset: 0,
      })
    );
    dispatch(getAllProperty());
  }, [dispatch]);

  // Ensure global loader stays hidden throughout component lifecycle
  useEffect(() => {
    const hideGlobalLoader = () => {
      const loaderElement = window.document.getElementById("loaderoverlay");
      if (loaderElement) {
        loaderElement.style.display = "none";
      }
    };

    // Hide immediately
    hideGlobalLoader();

    // Set interval to keep checking and hiding (in case other code tries to show it)
    const intervalId = setInterval(hideGlobalLoader, 100);

    // Cleanup on unmount
    return () => {
      clearInterval(intervalId);
    };
  }, []);

  useEffect(() => {
    const { response } = propertySelector;
    if (response?.status === 200) {
      setPropertyList(handleListResponse(response.data));
    } else {
      setPropertyList([]);
    }
  }, [propertySelector]);

  useEffect(() => {
    if (reportDatas?.data) {
      // Handle both old format (array) and new format (object with data and total)
      if (Array.isArray(reportDatas.data)) {
        setReportData(reportDatas.data);
        setTotalRecords(reportDatas.total || reportDatas.data.length);
      } else if (reportDatas.data.records || reportDatas.data.data) {
        // New backend pagination format
        const records = reportDatas.data.records || reportDatas.data.data;
        setReportData(records);
        setTotalRecords(
          reportDatas.data.total ||
            reportDatas.data.totalCount ||
            records.length
        );
      } else {
        setReportData(reportDatas.data);
        setTotalRecords(reportDatas.data.length);
      }
      setLoading(false);
      setApiError(false);
      setErrorMessage("");
    } else if (
      reportDatas?.error ||
      (reportDatas && !reportDatas.data && reportDatas.status !== 200)
    ) {
      setLoading(false);
      setApiError(true);
      setErrorMessage(
        reportDatas?.message ||
          reportDatas?.error ||
          "Failed to fetch data. Please try again."
      );
      setReportData(null);
      setTotalRecords(0);
    }
  }, [reportDatas]);

  const handleSelectChange = (selectedOption) => {
    setForm({
      ...form,
      property_title: selectedOption ? selectedOption.value : "",
    });
  };

  const handleValid = () => {
    let err = { ...formVaild };
    let formError = false;

    // If dates are provided, both should be there. Otherwise, show an error.
    if (
      (form.start_date && !form.end_date) ||
      (!form.start_date && form.end_date)
    ) {
      formError = true;
      err["date"] = strings.startEndDateErr;
    }

    setFormVaild(err);
    return formError;
  };

  // Handle page change
  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
    setLoading(true);
    const offset = newPage;

    // Call API with pagination and filter params
    dispatch(
      getDepostionReport({
        ...form,
        limit: itemsPerPage,
        offset: offset,
      })
    );
  };

  const filterDetail = () => {
    if (!handleValid()) {
      setReportData([]);
      setLoading(true);
      setApiError(false);
      setErrorMessage("");
      setCurrentPage(0); // Reset to first page

      // Call API with filter and pagination params
      dispatch(
        getDepostionReport({
          ...form,
          limit: itemsPerPage,
          offset: 0,
        })
      );
    }
  };

  const filterReset = () => {
    setForm({
      property_title: "",
      start_date: todayDate,
      end_date: todayDate,
    });
    setLoading(true); // Show loading spinner when resetting the form
    setApiError(false);
    setErrorMessage("");
    setCurrentPage(0); // Reset to first page

    // Call API with pagination params only
    dispatch(
      getDepostionReport({
        limit: itemsPerPage,
        offset: 0,
      })
    );
  };

  const handleInputField = (e) => {
    const nextFormState = {
      ...form,
      [e.target.name]: e.target.value,
    };
    setForm(nextFormState);
    setFormVaild({ ...formVaild, [e.target.name]: "" });
  };

  useEffect(() => {
    if (form.start_date === "") {
      setEndDateDisable(true);
    } else {
      setEndDateDisable(false);
    }
  }, [form.start_date]);

  const formatDate = (date) => {
    if (!date) return "N/A";

    const d = new Date(date);
    const day = ("0" + d.getDate()).slice(-2);
    const month = ("0" + (d.getMonth() + 1)).slice(-2);
    const year = d.getFullYear();

    return `${day}/${month}/${year}`;
  };

  const capitalizeWords = (text = "") => {
    if (typeof text !== "string") {
      return "";
    }

    return text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const exportToExcel = async () => {
    // Note: This will export only the current page data (10 records)
    // To export all data, you would need to call API with limit=totalRecords, offset=0
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Disposition Report");

    const getAppointmentStatus = (status) => {
      switch (status) {
        case 1:
          return "Not Visit";
        case 2:
          return "Revisit";
        case 3:
          return "Booking";
        case 4:
          return "Visit Cancel";
        case 5:
          return "Reschedule";
        case 6:
          return "Not fit for sale";
        case 10:
          return "Follow-up";
        default:
          return "N/A";
      }
    };

    if (!form.property_title) {
      // worksheet.columns = [
      //   { header: "Sr.No.", key: "sr_no", width: 10 },
      //   { header: "Region", key: "region", width: 15 },
      //   { header: "Visit Type", key: "revisitType", width: 15 },
      //   { header: "Date", key: "created_date", width: 15 },
      //   { header: "Client Name", key: "customer_name", width: 20 },
      //   { header: "Property Title", key: "property_name", width: 40 },
      //   { header: "Mobile", key: "customer_mobile", width: 20 },
      //   // { header: "Role Title", key: "role_title", width: 20 },
      //   { header: "Email", key: "customer_email", width: 30 },
      //   { header: "Resi. Location", key: "customer_location", width: 20 },
      //   { header: "Profession", key: "customer_designation", width: 20 },
      //   { header: "Work Location", key: "customer_office_address", width: 20 },
      //   { header: "Ethnicity", key: "ethnicity", width: 20 },
      //   { header: "Visiting With", key: "visit_with", width: 20 },
      //   { header: "Visitor Status", key: "qualified", width: 20 },
      //   { header: "Lead Priority", key: "lead_priority", width: 20 },
      //   {
      //     header: "Possession Period",
      //     key: "expected_possession_period",
      //     width: 25,
      //   },
      //   { header: "Config", key: "configuration", width: 15 },
      //   { header: "Budget", key: "budget", width: 15 },
      //   { header: "Purpose", key: "purpose", width: 20 },
      //   { header: "Lead Source", key: "lead_source", width: 20 },
      //   { header: "CP Firm Name", key: "cp_firm_name", width: 50 },
      //   { header: "CP Name", key: "cp_name", width: 50 },
      //   { header: "CP Contact", key: "cp_contact", width: 20 },
      //   { header: "RERA Number", key: "rera_number", width: 20 },
      //   { header: "Referrer Name", key: "referrer_name", width: 30 },
      //   { header: "Referrer Contact", key: "referrer_contact", width: 20 },
      //   { header: "Sourcing Manager", key: "sourcing_manager", width: 30 },
      //   { header: "Closing Manager", key: "closing_manager", width: 30 },
      //   { header: "Lead Status", key: "lead_status", width: 20 },
      //   {
      //     header: "Walkin - Remark",
      //     key: "first_appointment_remarks",
      //     width: 60,
      //   },
      //   { header: "1st Follow-Up Date", key: "first_followup_date", width: 30 },
      //   { header: "Follow-up Remark", key: "last_followup_remark", width: 60 },
      //   // { header: "NFD", key: "second_followup_date", width: 20 },
      //   // { header: 'STATUS', key: 'followup_status', width: 20 },
      //   { header: "Lost Reason", key: "lost_reason", width: 60 },
      //   { header: "Lost Remark", key: "lost_remark", width: 60 },
      //   { header: "Revisit Date", key: "revisit_appointment", width: 20 },
      // ];
      worksheet.columns = columnsForExcel;

      worksheet.getRow(1).eachCell((cell) => {
        cell.font = {
          bold: true,
          size: 14,
          color: { argb: "FFFFFF" },
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "4F81BD" },
        };
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };
      });

      reportData.forEach((item, index) => {
        const createdDate = item.createddate
          ? formatDate(item.createddate)
          : "N/A";
        const firstFollowupDate = item.first_followup_date
          ? formatDate(item.first_followup_date)
          : "N/A";
        const revisitDate =
          item.revisit === 2 ? formatDate(item.revisit_appointment) : "N/A";
        // const secondFollowupDate = item.second_followup_date
        //   ? formatDate(item.second_followup_date)
        //   : "N/A";

        worksheet.addRow({
          sr_no: index + 1,
          revisitType: item.revisitType,
          region: item.region || "N/A",
          created_date: createdDate,
          customer_name: item.customer_name || "N/A",
          property_name: item.property_name || "N/A",
          customer_mobile: item.customer_mobile || "N/A",
          customer_email: item.customer_email || "N/A",
          // role_title: item.role_title || "N/A",
          customer_location: item.customer_location || "N/A",
          customer_designation: item.customer_designation || "N/A",
          customer_office_address: item.customer_office_address || "N/A",
          ethnicity: item.ethnicity || "N/A",
          visit_with: capitalizeWords(item.visit_with) || "N/A",
          qualified:
            item.qualified === true
              ? "Qualified"
              : item.qualified === false
              ? "Unqualified"
              : "N/A",
          lead_priority: capitalizeWords(item.lead_priority) || "N/A",
          expected_possession_period: item.expected_possession_period
            ? item.expected_possession_period
            : item.expected_possession_date
            ? formatDate(item.expected_possession_date)
            : "N/A",
          configuration: item.configuration || "N/A",
          budget: item.max_budget || "N/A",
          purpose: item.purpose || "N/A",
          lead_source:
            item.referrel_partner === 1
              ? "Referral Partner"
              : item.lead_source_title || "N/A",
          cp_firm_name: item.cp_firm_name || "N/A",
          cp_name: item.cp_name || "N/A",
          cp_contact: item.cp_contact || "N/A",
          rera_number: item.rera_certificate_no || "N/A",
          referrer_name: item.referrer_name || "N/A",
          referrer_contact: item.referrer_contact || "N/A",
          sourcing_manager: item.sourcing_manager || "N/A",
          closing_manager: item.closing_manager || "N/A",
          lead_status:
            getAppointmentStatus(item.first_appointment_status) || "N/A",
          first_appointment_remarks: item.first_appointment_remarks || "N/A",
          first_followup_date: firstFollowupDate,
          last_followup_remark: item.last_followup_remark || "N/A",
          // second_followup_date: secondFollowupDate,
          // followup_status: item.followup_status || 'N/A',
          lost_reason: item.lost_reason_status_6 || "N/A",
          lost_remark: item.remarks_status_6 || "N/A",
          revisit_appointment: revisitDate,
        });
      });
    } else {
      // worksheet.columns = [
      //   { header: "Sr.No.", key: "sr_no", width: 10 },
      //   { header: "Region", key: "region", width: 15 },
      //   { header: "Visit Type", key: "revisitType", width: 15 },
      //   { header: "Date", key: "created_date", width: 15 },
      //   { header: "Property Title", key: "property_name", width: 40 },
      //   { header: "Client Name", key: "customer_name", width: 20 },
      //   { header: "Mobile", key: "customer_mobile", width: 20 },
      //   // { header: "Role Title", key: "role_title", width: 20 },
      //   { header: "Email", key: "customer_email", width: 30 },
      //   { header: "Resi. Location", key: "customer_location", width: 20 },
      //   { header: "Profession", key: "customer_designation", width: 20 },
      //   { header: "Work Location", key: "customer_office_address", width: 20 },
      //   { header: "Ethnicity", key: "ethnicity", width: 20 },
      //   { header: "Visiting With", key: "visit_with", width: 20 },
      //   { header: "Visitor Status", key: "qualified", width: 20 },
      //   { header: "Lead Priority", key: "lead_priority", width: 20 },
      //   {
      //     header: "Possession Period",
      //     key: "expected_possession_period",
      //     width: 25,
      //   },
      //   { header: "Config", key: "configuration", width: 15 },
      //   { header: "Budget", key: "budget", width: 15 },
      //   { header: "Purpose", key: "purpose", width: 20 },
      //   { header: "Lead Source", key: "lead_source", width: 20 },
      //   { header: "CP Firm Name", key: "cp_firm_name", width: 50 },
      //   { header: "CP Name", key: "cp_name", width: 50 },
      //   { header: "CP Contact", key: "cp_contact", width: 20 },
      //   { header: "RERA Number", key: "rera_number", width: 20 },
      //   { header: "Referrer Name", key: "referrer_name", width: 30 },
      //   { header: "Referrer Contact", key: "referrer_contact", width: 20 },
      //   { header: "Sourcing Manager", key: "sourcing_manager", width: 30 },
      //   { header: "Closing Manager", key: "closing_manager", width: 30 },
      //   { header: "Lead Status", key: "lead_status", width: 20 },
      //   {
      //     header: "Walkin - Remark",
      //     key: "first_appointment_remarks",
      //     width: 60,
      //   },
      //   { header: "1st Follow-Up Date", key: "first_followup_date", width: 30 },
      //   { header: "Follow-up Remark", key: "last_followup_remark", width: 60 },
      //   // { header: "NFD", key: "second_followup_date", width: 20 },
      //   // { header: 'STATUS', key: 'followup_status', width: 20 },
      //   { header: "Lost Reason", key: "lost_reason", width: 60 },
      //   { header: "Lost Remark", key: "lost_remark", width: 60 },
      //   { header: "Revisit Date", key: "revisit_appointment", width: 20 },
      // ];
      worksheet.columns = columnsForExcel;
      worksheet.getRow(1).eachCell((cell) => {
        cell.font = {
          bold: true,
          size: 14,
          color: { argb: "FFFFFF" },
        };
        cell.alignment = { vertical: "middle", horizontal: "center" };
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "4F81BD" },
        };
        cell.border = {
          top: { style: "thin", color: { argb: "000000" } },
          left: { style: "thin", color: { argb: "000000" } },
          bottom: { style: "thin", color: { argb: "000000" } },
          right: { style: "thin", color: { argb: "000000" } },
        };
      });

      reportData.forEach((item, index) => {
        const createdDate = item.createddate
          ? formatDate(item.createddate)
          : "N/A";
        const firstFollowupDate = item.first_followup_date
          ? formatDate(item.first_followup_date)
          : "N/A";
        const revisitDate =
          item.revisit === 2 ? formatDate(item.revisit_appointment) : "N/A";
        // const secondFollowupDate = item.second_followup_date
        //   ? formatDate(item.second_followup_date)
        //   : "N/A";

        worksheet.addRow({
          sr_no: index + 1,
          revisitType: item.revisitType,
          region: item.region || "N/A",
          created_date: createdDate,
          property_name: item.property_name || "N/A",
          customer_name: item.customer_name || "N/A",
          customer_mobile: item.customer_mobile || "N/A",
          // role_title: item.role_title || "N/A",
          customer_email: item.customer_email || "N/A",
          customer_location: item.customer_location || "N/A",
          customer_designation: item.customer_designation || "N/A",
          customer_office_address: item.customer_office_address || "N/A",
          ethnicity: item.ethnicity || "N/A",
          visit_with: capitalizeWords(item.visit_with) || "N/A",
          qualified:
            item.qualified === true
              ? "Qualified"
              : item.qualified === false
              ? "Unqualified"
              : "N/A",
          lead_priority: capitalizeWords(item.lead_priority) || "N/A",
          expected_possession_period: item.expected_possession_period
            ? item.expected_possession_period
            : item.expected_possession_date
            ? formatDate(item.expected_possession_date)
            : "N/A",
          configuration: item.configuration || "N/A",
          budget: item.max_budget || "N/A",
          purpose: item.purpose || "N/A",
          lead_source:
            item.referrel_partner === 1
              ? "Referral Partner"
              : item.lead_source_title || "N/A",
          cp_firm_name: item.cp_firm_name || "N/A",
          cp_name: item.cp_name || "N/A",
          cp_contact: item.cp_contact || "N/A",
          rera_number: item.rera_certificate_no || "N/A",
          referrer_name: item.referrer_name || "N/A",
          referrer_contact: item.referrer_contact || "N/A",
          sourcing_manager: item.sourcing_manager || "N/A",
          closing_manager: item.closing_manager || "N/A",
          lead_status:
            getAppointmentStatus(item.first_appointment_status) || "N/A",
          first_appointment_remarks: item.first_appointment_remarks || "N/A",
          first_followup_date: firstFollowupDate,
          last_followup_remark: item.last_followup_remark || "N/A",
          // second_followup_date: secondFollowupDate,
          // followup_status: item.followup_status || 'N/A',
          lost_reason: item.lost_reason_status_6 || "N/A",
          lost_remark: item.remarks_status_6 || "N/A",
          revisit_appointment: revisitDate,
        });
      });
    }

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "disposition_report.xlsx";
    a.click();
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="page-body">
      {isAuth && (
        <Breadcrumb
          title={strings.depositionReport}
          parentListing={null}
          titleactive={strings.depositionReport}
        />
      )}
      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <div className="card-body">
              <form className="theme-form">
                <div className="row">
                  <div className="col-md-4">
                    <span className="cardText">{strings.startDate}</span>
                    <div
                      className="input-group date"
                      id="dt-date"
                      data-target-input="nearest"
                    >
                      <input
                        className="form-control datetimepicker-input digits"
                        type="date"
                        data-target="#dt-date"
                        name="start_date"
                        value={form.start_date}
                        onChange={handleInputField}
                        // min={form.start_date}
                      />
                    </div>
                    {formVaild.start_date && (
                      <span style={{ color: "red" }}>
                        {formVaild.start_date}
                      </span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <span className="cardText">{strings.endDate}</span>
                    <div
                      className="input-group date"
                      id="dt-date"
                      data-target-input="nearest"
                    >
                      <input
                        className="form-control datetimepicker-input digits"
                        type="date"
                        name="end_date"
                        value={form.end_date}
                        onChange={handleInputField}
                        min={form.start_date}
                        // max={form.end_date}
                        disabled={endDateDisable}
                      />
                    </div>
                    {formVaild.end_date && (
                      <span style={{ color: "red" }}>{formVaild.end_date}</span>
                    )}
                  </div>
                  <div className="col-md-4">
                    <span className="cardText">{strings.propertyName}</span>

                    <Select
                      isDisabled={propertyList.length === 0}
                      className="basic-single"
                      classNamePrefix="select"
                      isSearchable
                      isClearable
                      options={propertyList.map((property) => ({
                        value: property.property_title,
                        label: property.property_title,
                      }))}
                      value={
                        form.property_title
                          ? {
                              label: form.property_title,
                              value: form.property_title,
                            }
                          : null
                      }
                      onChange={handleSelectChange}
                      placeholder="Select property"
                    />
                  </div>
                </div>

                <div className="row pt-3">
                  <div className="col-md-12 pt-4">
                    <div className="form-group d-flex justify-content-end">
                      <button
                        className="btn btn-warning "
                        type="button"
                        onClick={filterDetail}
                      >
                        {strings.submit}
                      </button>
                      <button
                        className="btn btn-dark ml-2"
                        type="button"
                        onClick={filterReset}
                      >
                        {strings.reset}
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>

          <hr />
          {reportData && reportData.length > 0 && (
            <div className="d-flex  mb-4 justify-content-end">
              <button className="btn btn-primary" onClick={exportToExcel}>
                Export to Excel
              </button>
            </div>
          )}

          <div className="card">
            <div className="card-body">
              <div ref={tableContainerRef}>
                {apiError ? (
                  <div style={{ padding: "40px 20px", textAlign: "center" }}>
                    <div
                      style={{
                        fontSize: "48px",
                        color: "#dc3545",
                        marginBottom: "20px",
                      }}
                    >
                      <i className="fa fa-exclamation-circle"></i>
                    </div>
                    <h5 style={{ color: "#dc3545", marginBottom: "10px" }}>
                      Error Loading Data
                    </h5>
                    <p style={{ color: "#666", marginBottom: "20px" }}>
                      {errorMessage}
                    </p>
                    {/* <button 
                      className="btn btn-primary" 
                      onClick={() => {
                        setApiError(false);
                        setLoading(true);
                        dispatch(getDepostionReport({ ...form }));
                      }}
                    >
                      Try Again
                    </button> */}
                  </div>
                ) : !loading && reportData && reportData.length === 0 ? (
                  <div style={{ padding: "20px", textAlign: "center" }}>
                    No data available.
                  </div>
                ) : (
                  <div>
                    <table
                      className="table table-striped table-bordered table-sm table-responsive"
                      style={{
                        overflowY: "auto",
                        overflowX: "auto",
                        maxHeight: "500px",
                        height: "500px",
                        position: "relative",
                      }}
                    >
                      <thead
                        style={{
                          backgroundColor: "#ffffff",
                          color: "#000",
                          position: "sticky",
                          top: "0",
                          zIndex: 1,
                        }}
                      >
                        <tr>
                          <th style={{ minWidth: "30px" }}>Sr.No.</th>
                          <th style={{ minWidth: "100px" }}>Region</th>
                          <th style={{ minWidth: "150px" }}>Visit Type</th>
                          <th style={{ minWidth: "100px" }}>Date</th>
                          <th style={{ minWidth: "200px" }}>Client Name</th>
                          <th style={{ minWidth: "150px" }}>Mobile</th>
                          {/* <th style={{ minWidth: "150px" }}>Role Title</th> */}
                          <th style={{ minWidth: "200px" }}>Email</th>
                          <th style={{ minWidth: "200px" }}>Resi. Location</th>
                          <th style={{ minWidth: "200px" }}>Profession</th>
                          <th style={{ minWidth: "200px" }}>Work Location</th>
                          <th style={{ minWidth: "200px" }}>Ethnicity</th>
                          <th style={{ minWidth: "200px" }}>Visiting With</th>
                          <th style={{ minWidth: "200px" }}>Visitor Status</th>
                          <th style={{ minWidth: "200px" }}>Lead Priority</th>
                          <th style={{ minWidth: "200px" }}>
                            Possession Period
                          </th>
                          <th style={{ minWidth: "200px" }}>Config</th>
                          <th style={{ minWidth: "200px" }}>Budget</th>
                          <th style={{ minWidth: "200px" }}>Purpose</th>
                          <th style={{ minWidth: "200px" }}>Lead Source</th>
                          <th style={{ minWidth: "200px" }}>CP Firm Name</th>
                          <th style={{ minWidth: "200px" }}>CP Name</th>
                          <th style={{ minWidth: "200px" }}>CP Contact</th>
                          <th style={{ minWidth: "200px" }}>RERA Number</th>
                          <th style={{ minWidth: "200px" }}>Referrer Name</th>
                          <th style={{ minWidth: "200px" }}>
                            Referrer Contact
                          </th>
                          <th style={{ minWidth: "200px" }}>
                            Sourcing Manager
                          </th>
                          <th style={{ minWidth: "200px" }}>Closing Manager</th>
                          <th style={{ minWidth: "200px" }}>Lead Status</th>
                          <th style={{ minWidth: "300px" }}>Walkin - Remark</th>
                          <th style={{ minWidth: "200px" }}>
                            1st Follow-Up Date
                          </th>
                          <th style={{ minWidth: "300px" }}>
                            Follow-up Remark
                          </th>
                          {/* <th style={{ minWidth: "200px" }}>NFD</th> */}
                          <th style={{ minWidth: "300px" }}>Lost Reason</th>
                          <th style={{ minWidth: "300px" }}>Lost Remark</th>
                          <th style={{ minWidth: "200px" }}>Revisit Date</th>
                        </tr>
                      </thead>
                      <tbody>
                        {reportData &&
                          reportData?.map((item, index) => (
                            <tr key={item._id}>
                              <td>{currentPage * itemsPerPage + index + 1}</td>
                              <td>{item.region || "N/A"}</td>
                              <td>{item.revisitType || "N/A"}</td>
                              <td>
                                {item.createddate
                                  ? formatDate(item.createddate)
                                  : "N/A"}
                              </td>
                              <td>{item.customer_name || "N/A"}</td>
                              <td>{item.customer_mobile || "N/A"}</td>
                              {/* <td>{item.role_title || "N/A"}</td> */}
                              <td>{item.customer_email || "N/A"}</td>
                              <td>
                                {capitalizeWords(item.customer_location) ||
                                  "N/A"}
                              </td>
                              <td>{item.customer_designation || "N/A"}</td>
                              <td>
                                {capitalizeWords(
                                  item.customer_office_address
                                ) || "N/A"}
                              </td>
                              <td>{item.ethnicity || "N/A"}</td>
                              <td>
                                {capitalizeWords(item.visit_with) || "N/A"}
                              </td>
                              <td>
                                {item.qualified === true
                                  ? strings.qualified
                                  : item.qualified === false
                                  ? strings.unQualified
                                  : "N/A"}
                              </td>
                              <td>
                                {capitalizeWords(item.lead_priority) || "N/A"}
                              </td>
                              <td>
                                {item.expected_possession_period
                                  ? item.expected_possession_period
                                  : item.expected_possession_date
                                  ? formatDate(item.expected_possession_date)
                                  : "N/A"}
                              </td>
                              <td>{item.configuration || "N/A"}</td>
                              <td>{item.max_budget}</td>
                              <td>{item.purpose || "N/A"}</td>
                              <td>
                                {item.referrel_partner === 1
                                  ? "Referral Partner"
                                  : item.lead_source_title || "N/A"}
                              </td>
                              <td>{item.cp_firm_name || "N/A"}</td>
                              <td>{item.cp_name || "N/A"}</td>
                              <td>{item.cp_contact || "N/A"}</td>
                              <td>{item.rera_certificate_no || "N/A"}</td>
                              <td>
                                {capitalizeWords(item.referrer_name) || "N/A"}
                              </td>
                              <td>{item.referrer_contact || "N/A"}</td>
                              <td>{item.sourcing_manager || "N/A"}</td>
                              <td>{item.closing_manager || "N/A"}</td>
                              <td>
                                {item.first_appointment_status === 1
                                  ? "Not Visit"
                                  : item.first_appointment_status === 2
                                  ? "Revisit"
                                  : item.first_appointment_status === 3
                                  ? "Booking"
                                  : item.first_appointment_status === 4
                                  ? "Visit Cancel"
                                  : item.first_appointment_status === 5
                                  ? "Reschedule"
                                  : item.first_appointment_status === 6
                                  ? "Not fit for sale"
                                  : item.first_appointment_status === 10
                                  ? "Follow-up"
                                  : "N/A"}
                              </td>
                              <td>{item.first_appointment_remarks || "N/A"}</td>
                              <td>
                                {item.first_followup_date
                                  ? formatDate(item.first_followup_date)
                                  : "N/A"}
                              </td>
                              <td>{item.last_followup_remark || "N/A"}</td>
                              {/* <td>
                              {item.second_followup_date
                                ? formatDate(item.second_followup_date)
                                : "N/A"}
                            </td> */}
                              <td>{item.lost_reason_status_6 || "N/A"}</td>
                              <td>{item.remarks_status_6 || "N/A"}</td>
                              <td>
                                {item.revisit === 2
                                  ? formatDate(item.revisit_appointment)
                                  : "N/A"}
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                    {/* {isLoadingMore && (
                      <div
                        style={{
                          padding: "20px",
                          textAlign: "center",
                          backgroundColor: "#fff",
                          borderTop: "1px solid #dee2e6",
                        }}
                      >
                        <div
                          className="spinner-border text-primary"
                          role="status"
                          style={{ width: "2rem", height: "2rem" }}
                        >
                          <span className="sr-only">Loading more...</span>
                        </div>
                        <p style={{ margin: "10px 0 0 0", fontWeight: "500" }}>
                          Loading more records...
                        </p>
                      </div>
                    )} */}
                    {/* {reportData &&
                      visibleRecords < reportData.length &&
                      !isLoadingMore && (
                        <div
                          style={{
                            padding: "15px",
                            textAlign: "center",
                            color: "#007bff",
                            backgroundColor: "#e7f3ff",
                            borderTop: "1px solid #dee2e6",
                            cursor: "pointer",
                          }}
                        >
                          <i className="fa fa-arrow-down"></i> Scroll down to
                          load more ({reportData.length - visibleRecords}{" "}
                          remaining)
                        </div>
                      )}
                    {reportData &&
                      visibleRecords >= reportData.length &&
                      reportData.length > 10 && (
                        <div
                          style={{
                            padding: "15px",
                            textAlign: "center",
                            color: "#28a745",
                            backgroundColor: "#d4edda",
                            borderTop: "1px solid #dee2e6",
                          }}
                        >
                          <i className="fa fa-check-circle"></i> All{" "}
                          {reportData.length} records loaded
                        </div>
                      )} */}

                    {totalRecords > 0 && (
                      <Pagination
                        itemsPerPage={itemsPerPage}
                        totalCount={totalRecords}
                        listData={reportData || []}
                        onPageChange={handlePageChange}
                        itemOffset={currentPage}
                        setItemOffset={setCurrentPage}
                      />
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Loading Modal Popup */}
      {loading && (
        <div
          className="modal show"
          style={{
            display: "block",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 9999,
          }}
        >
          <div
            className="modal-dialog modal-dialog-centered"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              minHeight: "100vh",
            }}
          >
            <div className="modal-content" style={{ maxWidth: "400px" }}>
              <div
                className="modal-body text-center"
                style={{ padding: "40px 20px" }}
              >
                <div
                  className="spinner-border text-primary mb-3"
                  role="status"
                  style={{ width: "3rem", height: "3rem" }}
                >
                  <span className="sr-only">Loading...</span>
                </div>
                <h5 className="mb-2">Loading Data</h5>
                <p className="text-muted mb-0">
                  Please wait while we fetch the report data...
                </p>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DepositionReport;
